import axios from 'axios'
import {
    randomWord,
    getTimeStamp,
    getSign,
    tempLoginSign,
    getAeskey,
} from './sign.js'
import baseConfig from '../../../public/config.json'
import store from '../../store'
import TripleDES from './crypto.js'
//import { Base64 } from 'js-base64'
import eventBus from '../../components/common/event_bus.js'
import iView from 'view-design'
import Vue from 'vue'
import { Modal } from 'view-design';
//axios.defaults.shouldRetry=(error)=>false  //// 重试条件，默认只要是错误都需要重试
const reqUrl = baseConfig.realApiUrl
//连接1,定位
const ipios = axios.create({
    baseURL: baseConfig.ipApi,
    timeout: 8000,
})
//连接2 api
const ajax = axios.create({
    baseURL: reqUrl,
    // withCredentials:true,
})

var token_time_out =0

ajax.interceptors.request.use(config => {
    // console.log('request=============>');
    // console.log(Vue.prototype.$baseConfig)
    // config.baseURL()
    config.baseURL = Vue.prototype.$baseConfig.realApiUrl
    //console.log(config);
    return config
}, function(error) {
    console.log(error)
    return Promise.reject(error);
})
ajax.interceptors.response.use(resp => {
    //console.log('response=============>');
    //console.log(resp.config.shouldRetry())
    return resp
}, function(error) {
    console.log(error)
    return Promise.reject(error);
})


function GetIP() {
    return ipios({
        method: 'get',
        json: true
    })
}

//export const getTestCity=()=>axios.get('../../assets/json/tagCity.json')

// function host() {
//  return axios.get('http://localhost:8080/static/config.json')
// }

// async function GetHost() {
//   try {
//     const response = await axios.get('http://localhost:8080/static/config.json')
//   } catch (error) {
//     console.error(error);
//   }
// }


function HttpDownLoad(url, body, method, f, msg) {
    //console.log("url:"+url,"\nmethod:"+method)
    var client = new XMLHttpRequest();
    var randomStr = randomWord(true, 10, 16)
    var timestamp = getTimeStamp()
    var token = store.state.user.token
    var userGuid = store.state.user.userGuid
    console.log(
        "url:" + url,
        "\nmethod:" + method,
        "\ntoken:" + token,
        "\nrandomStr:" + randomStr,
        "\ntimestamp:" + timestamp,
        "\nbody:" + JSON.stringify(body))

    var sign = getSign(timestamp, randomStr, token, method === "get" ? "" : JSON.stringify(body))
    //Vue.prototype.$baseConfig.realApiUrl
    //uri: baseConfig.apiBaseUrl + url
    var options = {
        uri: Vue.prototype.$baseConfig.realApiUrl + url
    }
    client.open(method, options.uri);
    client.responseType = 'blob'
    client.setRequestHeader('xrd', randomStr);
    client.setRequestHeader('xts', timestamp);
    client.setRequestHeader('xguid', userGuid);
    client.setRequestHeader('xsn', sign);
    client.setRequestHeader('xen', true) //true需要加密


    client.onreadystatechange = function() {
        if (client.readyState === 4 && client.status === 200) {
            // console.log("开始下载...")
            // console.log(client)
            var name = client.getResponseHeader("Content-Language");
            var filename = decodeURIComponent(name); //name.substring(20, name.length);
            if (filename === undefined ||
                filename === null ||
                filename === "null" ||
                filename === "fail" ||
                filename === "") {
                var blob = new Blob([client.response], { type: 'plain/text', endings: 'native' });
                var reader = new FileReader();
                reader.readAsText(blob);
                reader.onload = function() {
                    var rData = JSON.parse(this.result)
                    console.log(rData)
                    if (rData.rtncode === -99 || rData.rtncode === -91) {

                        //临时用户不提示重新登录，执行重登录
                        if (store.state.user.userId === '') {
                            sessionStorage.clear()
                            return TempUserlogin().then(res => {
                                console.log("拦截到-99,-91，身份:临时用户,执行临时登录")
                                console.log(res)
                                //eventBus.$emit("user-logoff", "true") //注销用户,刷新ui
                                //store.commit("setLoginForm", false)//清除登录状态模式框和ui
                                setTempLoginState(res)
                                if (method === 'get') {
                                    return HttpGet(url, params)
                                        .then(function(resp) {
                                            resolve(resp)
                                        }).catch(function(err) {
                                            reject(err)
                                        })
                                } else if (method === 'post') {
                                    // console.log("重发post请求,url:" + url + "params:" + params)
                                    return HttpPost(url, params, nodes)
                                        .then(function(rsp) {
                                            resolve(rsp)
                                        }).catch(function(err) {
                                            reject(err)
                                        })
                                }
                            }).catch(err => {
                                // console.log("token失效,重登录失败,原因:" + err)
                                reject(err);
                            })
                        } else {
                            sessionStorage.clear()
                            //Vue.prototype.$Tools.showMask()
                            setTimeout(() => {
                                //Vue.prototype.$Modal.remove()
                                Vue.prototype.$Modal.info({
                                    title: '提示',
                                    content: '<p>登录超时，请重新登录</p>',
                                    okText: '重新登录',
                                    onOk: () => {
                                        //处理无头情况
                                        if(store.state.user.isjxt){
                                            let hosturl ='/home?g=1'
                                            console.log('处理无头情况:'+hosturl)
                                            window.location.assign(hosturl);
                                        }else{
                                            window.location.reload()
                                        }
                                        
                                    }
                                })
                            }, 2000);
                        }
                        // console.log("-99临时登录....")
                        // eventBus.$emit("user-login", "true") //临时登录
                    } else if (rData.rltcode === -250) {
                        msg(rData.rltdesc)
                        if (f !== undefined) {
                            f() //回调关闭弹窗
                        }
                    } else {
                        if (f !== undefined) {
                            f() //回调关闭弹窗
                        }
                        if (msg !== undefined) {
                            msg("下载失败")
                        }
                    }
                }
            } else {
                blob = new Blob([client.response], { type: 'application/octet-stream' });
                var csvUrl = URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = csvUrl;
                link.download = filename;
                link.click();
                if (f !== undefined) {
                    f() //回调关闭弹窗
                }
            }


        } else if (client.readyState === 4 && client.status !== 200) {
            if (f !== undefined) {
                f() //回调关闭弹窗
            }
            if (msg !== undefined) {
                msg("下载失败")
            }
        } else {
            // console.log("client.readyState:" + client.readyState)
            // console.log("client.status:" + client.status)
        }
    };
    try {
        if (method === "get") {
            client.send();
        } else if (method === "post") {
            let aesKey = getAeskey(randomStr, store.state.user.token)
            let bodyEncrypt = TripleDES.encode(aesKey, body)
            client.send(JSON.stringify(bodyEncrypt));
        }
    } catch (e) {
        console.log(e)
    }


}




// function PostDownLoad(url, body) {
//   var client = new XMLHttpRequest();
//   var randomStr = randomWord(true, 10, 16)
//   var timestamp = getTimeStamp()
//   var token = store.state.user.token
//   var userGuid = store.state.user.userGuid
//   var sign = getSign(timestamp, randomStr, token, "")
//   var options = {
//     uri: baseConfig.apiBaseUrl + url,
//   }
//   client.open("post", options.uri);
//   client.responseType = 'blob'
//   client.setRequestHeader('xrd', randomStr);
//   client.setRequestHeader('xts', timestamp);
//   client.setRequestHeader('xguid', userGuid);
//   client.setRequestHeader('xsn', sign);
//   //console.log(client)
//   client.onreadystatechange = function() {
//     if (client.readyState === 4 && client.status === 200) {
//       var name = client.getResponseHeader("Content-Language");
//       var filename = decodeURIComponent(name); //name.substring(20, name.length);
//       var blob = new Blob([client.response], { type: 'application/octet-stream' });
//       var csvUrl = URL.createObjectURL(blob);
//       var link = document.createElement('a');
//       link.href = csvUrl;
//       link.download = filename;
//       link.click();

//     } else if (client.readyState === 4 && client.status === 204) {
//       // console.log("client.readyState:" + client.readyState)
//       // console.log("client.status:" + client.status)
//       console.log("下载出错")
//       // if (msg !== undefined) {
//       //   msg()
//       // }
//     } else {
//       console.log("client.readyState:" + client.readyState)
//       console.log("client.status:" + client.status)
//     }
//   };
//   try {
//     client.send(JSON.stringify(body));
//   } catch (e) {
//     console.log(e)
//   }


// }




function HttpGet(url, params) {
    var randomStr = randomWord(true, 10, 16)
    var timestamp = getTimeStamp()
    var token = store.state.user.token
    var userGuid = store.state.user.userGuid
    var sign = getSign(timestamp, randomStr, token, "")
    //console.log("u:"+userId)
    var options = {
        uri: reqUrl + url,
        qs: params,
        headers: {
            'content-type': 'application/json',
            'xrd': randomStr,
            'xts': timestamp,
            //'x-user': userId,
            'xguid': userGuid,
            'xsn': sign
        },
        resolveWithFullResponse: true,
        json: true // Automatically parses the JSON string in the response
    }
    // console.log("http get==========>")
    // console.log(options)
    iView.LoadingBar.start()
    // var rp = require('request-promise');
    //console.log(options.headers)
    return new Promise((resolve, reject) => {
        ajax({
                url: url,
                headers: options.headers,
                method: 'get',
                params: params,
                json: true
            })
            .then(function(response) {
                //console.log(response)
                if (response.headers.xen !== undefined && response.headers.xen === "true") {
                    let aesKey = getAeskey(response.headers.xrd, store.state.user.token)
                    let data = TripleDES.decode(aesKey, response.data)
                    // console.log('get.response->')
                    //console.log(url)
                    resolve(data)
                } else {
                    resolve(response.data)
                }
                iView.LoadingBar.finish()
            })
            .catch(function(error) {
                iView.LoadingBar.error()
                reject(error);
                console.log(error);
            })
            .finally(function() {
                // always executed
            });

        // rp(options).then(response => {
        //   if (response.headers.xen !== undefined && response.headers.xen === "true") {
        //     let aesKey = getAeskey(response.headers.xrd, store.state.user.token)
        //     let data = TripleDES.decode(aesKey, response.body)
        //     resolve(data)
        //   } else {
        //     resolve(response.body)
        //   }
        //   iView.LoadingBar.finish()
        // }).catch(err => {
        //   iView.LoadingBar.error()
        //   reject(err);
        // })


    })
    // return rp(options)
}

function HttpGet2(url, params) {
    var randomStr = randomWord(true, 10, 16)
    var timestamp = getTimeStamp()
    var token = store.state.user.token
    var userGuid = store.state.user.userGuid
    var sign = getSign(timestamp, randomStr, token, "")
    //console.log("u:"+userId)
    var options = {
        uri: reqUrl + url,
        qs: params,
        headers: {
            'content-type': 'application/json',
            // 'xrd': randomStr,
            // 'xts': timestamp,
            // //'x-user': userId,
            // 'xguid': userGuid,
            // 'xsn': sign
        },
        resolveWithFullResponse: true,
        json: true // Automatically parses the JSON string in the response
    }
    // console.log("http get==========>")
    // console.log(options)
    iView.LoadingBar.start()
    // var rp = require('request-promise');
    //console.log(options.headers)
    return new Promise((resolve, reject) => {
        ajax({
                url: url,
                headers: options.headers,
                method: 'get',
                params: params,
                json: true
            })
            .then(function(response) {
                //console.log(response)
                if (response.headers.xen !== undefined && response.headers.xen === "true") {
                    //let aesKey = getAeskey(response.headers.xrd, store.state.user.token)
                    //let data = TripleDES.decode(aesKey, response.data)
                    // console.log('get.response->')
                    //console.log(url)
                    let data=response.data
                    resolve(data)
                } else {
                    resolve(response.data)
                }
                iView.LoadingBar.finish()
            })
            .catch(function(error) {
                iView.LoadingBar.error()
                reject(error);
                console.log(error);
            })
            .finally(function() {
                // always executed
            });
    })
}

function HttpPost(url, bodyJson, nodes) {
    //

    var randomStr = randomWord(true, 10, 16)
    var timestamp = getTimeStamp()
    var token = store.state.user.token
    var userGuid = store.state.user.userGuid
    let aesKey = getAeskey(randomStr, store.state.user.token)
    let body
    if (nodes) {
        body = bodyJson
    } else {
        body = TripleDES.encode(aesKey, bodyJson)
    }

    var sign = getSign(timestamp, randomStr, token, JSON.stringify(bodyJson))
    //console.log("key:"+aesKey)
    // console.log("userId:"+userId)
    var options = {
        method: 'post',
        uri: reqUrl + url,
        headers: {
            'content-type': 'application/json',
            'xrd': randomStr,
            'xts': timestamp,
            //'x-user': userId,
            'xguid': userGuid,
            'xsn': sign,
            'xen': nodes ? false : true, //true=加密
        },
        body: body,
        resolveWithFullResponse: true,
        json: true // Automatically stringifies the body to JSON
    }
    //var rp = require('request-promise');
    //return rp(options)
    iView.LoadingBar.start()
    return new Promise((resolve, reject) => {
        ajax({
                url: url,
                headers: options.headers,
                data: options.body,
                method: 'post',
                json: true
            })
            .then(function(response) {
                //console.log(response)
                if (response.headers.xen !== undefined && response.headers.xen === "true") {
                    let aesKey = getAeskey(response.headers.xrd, store.state.user.token)
                    let data = TripleDES.decode(aesKey, response.data)
                    resolve(data)
                } else {
                    resolve(response.data)
                }
                iView.LoadingBar.finish()
            })
            .catch(function(error) {
                iView.LoadingBar.error()
                reject(error);
                console.log(error);
            })
            .finally(function() {
                // always executed
            });
        // rp(options).then(response => {
        //   if (response.headers.xen !== undefined && response.headers.xen === "true") {
        //     let aesKey = getAeskey(response.headers.xrd, store.state.user.token)
        //     let data = TripleDES.decode(aesKey, response.body)
        //     resolve(data)
        //   } else {
        //     resolve(response.body)
        //   }
        //   iView.LoadingBar.finish()
        //   //resolve(response.body)
        // }).catch(err => {
        //   iView.LoadingBar.error()
        //   reject(err);
        // })

    })
}

function HttpPost2(url, bodyJson) {
    var options = {
        method: 'POST',
        //uri: baseConfig.apiBaseUrl + url,
        body: bodyJson,
        json: true // Automatically stringifies the body to JSON
    }
    //var rp = require('request-promise');
    iView.LoadingBar.start()
    return new Promise((resolve, reject) => {
        ajax({
                url: url,
                method: 'post',
                headers: {
                    'content-type': 'application/json',
                    'xrd': '',
                    'xts': '',
                    'xguid': '',
                    'xsn': ''
                },
                data: options.body,
                json: true
            })
            .then(function(response) {
                //console.log(response)
                resolve(response.data)
                iView.LoadingBar.finish()
            })
            .catch(function(error) {
                iView.LoadingBar.error()
                reject(error);
                console.log(error);
            })
            .finally(function() {
                // always executed
            });
    })
}

function HttpPost3(url, bodyJson) {
    var options = {
        method: 'POST',
        //uri: baseConfig.apiBaseUrl + url,
        body: bodyJson,
        json: true // Automatically stringifies the body to JSON
    }
    //var rp = require('request-promise');
    iView.LoadingBar.start()
    var token = store.state.user.token
    return new Promise((resolve, reject) => {
        ajax({
                url: url,
                method: 'post',
                headers: {
                    'content-type': 'application/json',
                    'xrd': '',
                    'xts': '',
                    'xguid': '',
                    'xsn': '',
                    'xtoken':options.body.xtoken,
                },
                data: '',//body传空
                json: true
            })
            .then(function(response) {
                //console.log(response)
                resolve(response.data)
                iView.LoadingBar.finish()
            })
            .catch(function(error) {
                iView.LoadingBar.error()
                reject(error);
                console.log(error);
            })
            .finally(function() {
                // always executed
            });
    })
}


function TempUserlogin() {
    //export const reqTempLogin = function () {
    var randomStr
    var timestamp
    var sign
    var password
    randomStr = randomWord(true, 10, 16)
    timestamp = getTimeStamp()
    password = baseConfig.tempLoginPwd
    sign = tempLoginSign(timestamp, randomStr, password)
    var bodyJson = {
        randstr: randomStr,
        timestamp: timestamp,
        sign: sign
    }
    var options = {
        method: 'POST',
        // uri: baseConfig.apiBaseUrl + "/api/public/login/tempuser",
        url: "/api/public/login/tempuser",
        body: bodyJson,
        json: true // Automatically stringifies the body to JSON
    }
    //var rp = require('request-promise');
    return new Promise((resolve, reject) => {
        ajax({
                url: options.url,
                headers: {
                    'content-type': 'application/json',
                    'xrd': randomStr,
                    'xts': timestamp,
                    'xguid': '',
                    'xsn': sign,
                    'xen': true,
                },
                method: 'post',
                data: options.body,
                json: true
            })
            .then(function(response) {
                resolve(response.data)
            })
            .catch(function(error) {
                reject(error)
            })
        // rp(options)
        //   .then(function(resp) {
        //     resolve(resp)
        //   }).catch(function(err) {
        //     reject(err)
        //   })
    })
}


function WebPost(url, bodyJson, nodes) {
    return new Promise((resolve, reject) => {
        var token = store.state.user.token
        if (token == "" || token == undefined || token == null) {
            return TempUserlogin().then(res => {
                console.log("token失效,重登录成功,开始执行请求...")
                setTempLoginState(res)
                return HttpPost(url, bodyJson, nodes)
                    .then(function(resp) {
                        resolve(resp)
                    }).catch(function(err) {
                        console.log("err:" + err)
                        reject(err)
                    })
            }).catch(err => {
                console.log("token失效,重登录失败,原因:" + err)
                reject(err)
            })
        } else {
            return HttpPost(url, bodyJson, nodes)
                .then(function(resp) {
                    return dispatchResponse(resp, url, bodyJson, 'post', nodes).then(function(rsp) {
                        resolve(rsp)
                    }).catch(function(err) {
                        reject(err)
                    })
                }).catch(function(err) {
                    reject(err)
                })
        }

    })
}


function WebGet(url, params) {
    return new Promise((resolve, reject) => {
        var token = store.state.user.token
        //console.log("token:"+token)
        //store.commit("setLoginForm",true)
        if (token == "" || token == undefined || token == null) {
            return TempUserlogin().then(res => {
                console.log("token失效,重登录成功,开始执行请求...")
                console.log(res)
                setTempLoginState(res)
                return HttpGet(url, params)
                    .then(function(resp) {
                        resolve(resp); //抛出一个结果的调用对象
                    }).catch(function(err) {
                        //console.log("st: "+err.statusCode)
                        reject(err);
                    })

                // dispatchResponse(resp, url, params, 'get').then(function(rsp) {
                //   console.log('dispatchResponse111...')
                //   console.log(rsp)
                //   resolve(rsp);
                // }).catch(function(err) {
                //   reject(err);
                // })


            }).catch(err => {
                console.log("token失效,重登录失败,原因:" + err)
                reject(err);
            })
        } else {
            return HttpGet(url, params)
                .then(function(resp) {
                    return dispatchResponse(resp, url, params, 'get').then(function(rsp) {
                            resolve(rsp);
                        })
                        .catch(function(err) {
                            reject(err);
                        })

                    //resolve(resp);
                }).catch(function(err) {
                    //console.log(err)
                    reject(err);
                })
        }
    })
}

function dispatchResponse(resp, url, params, method, nodes) {
    // console.log('dispatchResponse->')
    // console.log("url:"+url)
    // console.log(params)
    // console.log('method:'+method)
    return new Promise((resolve, reject) => {

        //console.log(resp)
        if (resp.rtncode === 1 && resp.rltcode === 1) {
            resolve(resp);
        } else if (resp.rtncode === -99 || resp.rtncode === -91) {
            //store.commit("setLoginForm", true)
            console.log("dispatchResponse -99======>")
            console.log("dispatchResponse->userid:" + store.state.user.userId)

            //临时用户不提示重新登录，执行重登录

            if (store.state.user.userId === '') {
                sessionStorage.clear()
                return TempUserlogin().then(res => {
                    console.log("拦截到-99,-91，身份:临时用户,执行临时登录")
                    console.log(res)
                    //eventBus.$emit("user-logoff", "true") //注销用户,刷新ui
                    //store.commit("setLoginForm", false)//清除登录状态模式框和ui
                    setTempLoginState(res)
                    if (method === 'get') {
                        return HttpGet(url, params)
                            .then(function(resp) {
                                resolve(resp)
                            }).catch(function(err) {
                                reject(err)
                            })
                    } else if (method === 'post') {
                        // console.log("重发post请求,url:" + url + "params:" + params)
                        return HttpPost(url, params, nodes)
                            .then(function(rsp) {
                                resolve(rsp)
                            }).catch(function(err) {
                                reject(err)
                            })
                    }
                }).catch(err => {
                    // console.log("token失效,重登录失败,原因:" + err)
                    reject(err);
                })
            } else {
                sessionStorage.clear()
                //Vue.prototype.$Tools.showMask()
                setTimeout(() => {
                    //Vue.prototype.$Modal.remove()
                    Vue.prototype.$Modal.info({
                        title: '提示',
                        content: '<p>登录超时，请重新登录</p>',
                        okText: '重新登录',
                        onOk: () => {
                            //处理无头情况，是否保持登录状态？
                            if(store.state.user.isjxt){
                                let hosturl ='/home?g=1'
                                console.log('处理无头情况:'+hosturl)
                                window.location.assign(hosturl);
                            }else{
                                window.location.reload()
                            }
            }
                    })
                }, 2000);
            }
            //window.location.reload()
            //eventBus.$emit("user-login", "true") //临时登录
            //denglu
            resolve(resp);
        } else if (resp.rtncode === -50) {
            console.log("签名错误!!!")
            sessionStorage.clear()
            //计算签名错误次数
            if (token_time_out>=3){
                console.log("签名错误次数过，已重定向到首页")
                window.location.reload()
            }else{
                token_time_out+=1
                console.log("签名错误!!!累计次数："+token_time_out)
            }   
            //处理无头情况
            if(store.state.user.isjxt){
                let hosturl ='/home?g=1'
                console.log('处理无头情况:'+hosturl)
                window.location.assign(hosturl);
            }else{
                window.location.reload()
            }
            //window.location.reload()
            //store.commit("setLoginForm", true)
            //eventBus.$emit("user-login", "true") //临时登录
            //denglu
            resolve(resp);
        } else if (resp.rtncode === -98) {
            //-91 用戶过期
            //tmplogin
            //token失效,清空session缓存
            sessionStorage.clear()
            store.commit('setUserLogout')
            store.state.user.tempLoginFalureTime += 1
            console.log("tempLoginFalureTime:" + store.state.user.tempLoginFalureTime)
            if (store.state.user.tempLoginFalureTime > 20) {
                //处理无头情况
                if(store.state.user.isjxt){
                    let hosturl ='/home?g=1'
                    console.log('处理无头情况:'+hosturl)
                    window.location.assign(hosturl);
                }else{
                    window.location.reload()
                }
            }
            return TempUserlogin().then(res => {
                console.log("temptoken失效,临时用户登录成功..." + url)
                console.log(res)
                //eventBus.$emit("user-logoff", "true") //注销用户,刷新ui
                //store.commit("setLoginForm", false)//清除登录状态模式框和ui
                setTempLoginState(res)

                if (method === 'get') {
                    return HttpGet(url, params)
                        .then(function(resp) {
                            resolve(resp)
                        }).catch(function(err) {
                            reject(err)
                        })
                } else if (method === 'post') {
                    // console.log("重发post请求,url:" + url + "params:" + params)
                    return HttpPost(url, params, nodes)
                        .then(function(rsp) {
                            resolve(rsp)
                        }).catch(function(err) {
                            reject(err)
                        })
                }

            }).catch(err => {
                // console.log("token失效,重登录失败,原因:" + err)
                reject(err);
            })
            //resolve(resp)
        } else {
            resolve(resp);
        }
    })
}


function setTempLoginState(resp) {
    //console.log(resp);

    var tempLoginUser = {
        userGuid: resp.userguid,
        userId: resp.userid,
        mobileNum: resp.mobilenum,
        realName: resp.realname,
        token: resp.token,
        //userType: resp.usertype,
        permission: resp.permission,

        accounttype: resp.accounttype,
        accountstatus: resp.accountstatus,
        freefolder: resp.freefolder,
        showmsg: resp.showmsg,


    }
    console.log('tempLoginUser' + tempLoginUser)
    if (tempLoginUser.accounttype === 0) {
        if (sessionStorage.st !== undefined) {
            console.log("临时用户session登录...")
            let ss = JSON.parse(sessionStorage.st)
            //console.log(ss)
            store.commit('setLoginUser', ss)
        } else {
            store.commit('setTempLoginUser', tempLoginUser)
        }
    } else if (tempLoginUser.accounttype === 3) {
        store.commit('setBusinessLoginUser', tempLoginUser)
    }


    // store.commit('setUserId', resp.userid)
    // store.commit('setUserGuid', resp.userguid)
    // store.commit('setRealName', '访客')
    // store.commit('setToken', resp.token)
    // store.commit('setIsLogin', true)
    // store.commit('setUserType',resp.userType)
}

export {
    WebPost,
    WebGet,
    HttpDownLoad,
    HttpPost3,
    HttpPost2,
    HttpGet2,
    HttpPost,
    GetIP,
}